<template>
  <div>
    <a id="custom-logout-btn" @click="kakaoLogout()"
      >카카오 로그아웃
      <!-- <a id="custom-logout-btn" 
        href="https://kauth.kakao.com/oauth/logout?client_id=896db591cc34282285d34bf240bc3193&logout_redirect_uri=http://192.168.0.39:9080/kakaoLogin"> -->
      <!-- <img
            src="https://k.kakaocdn.net/14/dn/btroDszwNrM/I6efHub1SN5KCJqLm1Ovx1/o.jpg"
            width="222"
            alt="카카오 로그아웃 버튼"
        /> -->
    </a>
  </div>
</template>

<script>
import { restApiKey } from "@/redcrm/api/kakaoApi.js";

export default {
  methods: {
    async kakaoLogout() {
      var host = window.location.host;
      var pro = window.location.protocol;
      const result = await restApiKey;
      const clientId = result.data;
      const redirectUri = pro + "//" + host + "/kakaoLogin";
      const a = document.getElementById("custom-logout-btn");
      a.setAttribute(
        "href",
        "https://kauth.kakao.com/oauth/logout?client_id=" +
          clientId +
          "&logout_redirect_uri=" +
          redirectUri
      );
    },
  },
};
</script>

<style></style>
